import { Card, CardBody, Col } from "reactstrap";
import { Badges } from "../../../AbstractElements";
import { CloseBadgesTitle } from "../../../Constants/Constants";
import { ImageBadgesData, CloseBadgesSubTitle } from "../../../Data/UiKits/Tag&Pills";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { XCircle } from "react-feather";

const CloseBadges = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={CloseBadgesTitle} span={CloseBadgesSubTitle} />
        <CardBody>
          <div className="badge-spacing image-badges">
            {ImageBadgesData.map((item, index) => (
              <Badges pill color="" className={`"common-align txt-${item.color === "light" ? "dark" : item.color} badge-l-${item.color} border border-${item.color}`} key={index}>
                {item.color}
                <XCircle className={`ms-1 stroke-${item.color === "light" ? "dark" : item.color}`} />
              </Badges>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CloseBadges;
